import { createWebHistory, createRouter } from 'vue-router';

import Dashboard from './dashboard.vue';
import Home from './components/home.vue';
// import pages_index from './components/page/index.vue';
import pages_show from './components/page/show.vue';
// import contacts_data_index from './components/contact_data/index.vue';
// import socials_index from './components/social/index.vue';
import contact_us_create from './components/contact_u/create.vue';
import courses_index from './components/course/index.vue';
import courses_show from './components/course/show.vue';
import dashboard_questions_filter from './components/question_sessions/dashboard_filter.vue';
import subscriptions_index from './components/subscription/index.vue';
import dashboard_home from './components/subscription/home.vue';
// import subscriptions_create from './components/subscribe/create.vue';
// import subscriptions_show from './components/subscription/show.vue';
// import questions_index from './components/question/index.vue';
// import questions_show from './components/question/show.vue';
// import universities_index from './components/university/index.vue';
// import question_categories_index from './components/question_category/index.vue';
// import subjects_index from './components/subject/index.vue';
import student_answers_index from './components/student_answer/index.vue';
// import student_answers_create from './components/student_answer/create.vue';
// import student_answers_edit from './components/student_answer/edit.vue';
// import student_answers_show from './components/student_answer/show.vue';
// import question_sessions_index from './components/question_sessions/index.vue';
// import question_sessions_create from './components/question_sessions/create.vue';
// import question_likes_create from './components/question_like/create.vue';
import question_discussions_index from './components/question_discussion/index.vue';
// import question_discussions_create from './components/question_discussion/create.vue';
// import question_discussions_edit from './components/question_discussion/edit.vue';
// import question_discussions_show from './components/question_discussion/show.vue';
// import discussion_reports_create from './components/discussion_report/create.vue';
// import question_suggestions_create from './components/question_suggestion/create.vue';
// import question_videos_index from './components/question_video/index.vue';
// import question_videos_show from './components/question_video/show.vue';
// import question_favorites_create from './components/question_favorite/create.vue';
import notes_index from './components/note/index.vue';
// import notes_create from './components/note/create.vue';
// import notes_edit from './components/note/edit.vue';
// import course_prices_index from './components/course_price/index.vue';
// import discussion_likes_create from './components/discussion_like/create.vue';
// import video_likes_create from './components/video_like/create.vue';
import question_sessions_show from './components/question_sessions/show.vue';
import usersEdit from './components/auth/edit.vue';

import Activation from './components/auth/Activation';
import Register from './components/auth/Register';
import Login from './components/auth/Login';
import user_password_email from './components/auth/passwordEmail.vue';
import user_password_reset from './components/auth/passwordReset.vue';
// import users_change_password from './components/auth/changePassword.vue';

import mock_exams_index from './components/mock_exam/index.vue';
import mock_exams_show from './components/mock_exam/show.vue';

import books_index from './components/books/index.vue';
import book_specialties_index from './components/book_specialtie/index.vue';
import book_chapters_index from './components/book_chapter/index.vue';
import book_sections_index from './components/book_section/index.vue';


import summary from "./components/performance/summary.vue";
import categoryPerformance from "./components/performance/CategoryPerformance.vue";
import user_password_change from './components/auth/changePassword.vue';
import user_verify from './components/auth/verify.vue';

const routes =  [
    {
        "name": "home",
        "path": "/",
        "component": Home
    },
    {
        "name": "dashboard",
        "path": "/dashboard",
        "component": Dashboard
    },
    {
        name: 'activation',
        path: '/activation',
        component: Activation
    },
    {
        name: 'login',
        path: '/courses-login',
        component: Login
    },
    {
        name: 'register',
        path: '/register',
        component: Register
    },
    {
        name: 'verify',
        path: '/auth/verify/:token',
        component: user_verify
    },
    {
        "name": "password.email",
        "path": "/password/email",
        "component": user_password_email
    },
    {
        "name": "password.reset",
        "path": "/password/reset/:token",
        "component": user_password_reset
    },
    {
        "name": "courses.index",
        "path": "/courses",
        "component": courses_index
    },
    {
        "name": "courses.show",
        "path": "/courses/:id",
        "component": courses_show
    },
    {
        "name": "users.edit",
        "path": "/users/edit",
        "component": usersEdit
    },
    {
        "name": "password.change",
        "path": "/password/change",
        "component": user_password_change
    },

    {
        "name": "dashboard.home",
        "path": "/dashboard/:subscribe_id",
        "component": dashboard_home
    },
    {
        "name": "questions.courses.filter",
        "path": "/dashboard/:subscribe_id/filter",
        "component": dashboard_questions_filter
    },
    {
        "name": "question_sessions.show",
        "path": "/dashboard/:subscribe_id/question_sessions/:session_id",
        "component": question_sessions_show
    },
    {
        "name": "student_answers.index",
        "path": "/dashboard/:subscribe_id/student_answers",
        "component": student_answers_index
    },
    {
        "name": "mock_exams.index",
        "path": "/dashboard/:subscribe_id/mock_exams",
        "component": mock_exams_index
    },
    {
        "name": "mock_exams.show",
        "path": "/dashboard/:subscribe_id/mock_exams/:exam_id",
        "component": mock_exams_show
    },
    {
        "name": "performance.summary",
        "path": "/dashboard/:subscribe_id/performance/summary",
        "component": summary
    },
    {
        "name": "performance.categories",
        "path": "/dashboard/:subscribe_id/performance/categories",
        "component": categoryPerformance
    },
    {
        "name": "question_discussions.index",
        "path": "/dashboard/:subscribe_id/question_discussions",
        "component": question_discussions_index
    },


    {
        "name": "books.index",
        "path": "/dashboard/:subscribe_id/books",
        "component": books_index
    },
    {
        "name": "book_specialties.index",
        "path": "/dashboard/:subscribe_id/book_specialties/:book_id",
        "component": book_specialties_index
    },
    {
        "name": "book_chapters.index",
        "path": "/dashboard/:subscribe_id/book_chapters/:specialty_id",
        "component": book_chapters_index
    },
    {
        "name": "book_sections.index",
        "path": "/dashboard/:subscribe_id/book_sections/:chapter_id",
        "component": book_sections_index
    },
    {
        "name": "notes.index",
        "path": "/dashboard/:subscribe_id/notes",
        "component": notes_index
    },

    {
        "name": "subscriptions.index",
        "path": "/subscriptions",
        "component": subscriptions_index
    },
    // {
    //     "name": "users.change_password",
    //     "path": "/:lang?/users/change_password",
    //     "component": users_change_password
    // },


    // {
    //     "name": "pages.index",
    //     "path": "/pages",
    //     "component": pages_index
    // },
    {
        "name": "pages.show",
        "path": "/pages/:id",
        "component": pages_show
    },
    // {
    //     "name": "contacts_data.index",
    //     "path": "/contacts_data",
    //     "component": contacts_data_index
    // },
    // {
    //     "name": "socials.index",
    //     "path": "/socials",
    //     "component": socials_index
    // },
    {
        "name": "contact_us.create",
        "path": "/contact_us/create",
        "component": contact_us_create
    },
    // {
    //     "name": "subscriptions.create",
    //     "path": "/subscriptions/create",
    //     "component": subscriptions_create
    // },
    // {
    //     "name": "subscriptions.show",
    //     "path": "/subscriptions/:id",
    //     "component": subscriptions_show
    // },
    // {
    //     "name": "questions.index",
    //     "path": "/questions",
    //     "component": questions_index
    // },
    // {
    //     "name": "questions.show",
    //     "path": "/questions/:id",
    //     "component": questions_show
    // },
    // {
    //     "name": "universities.index",
    //     "path": "/universities",
    //     "component": universities_index
    // },
    // {
    //     "name": "question_categories.index",
    //     "path": "/question_categories",
    //     "component": question_categories_index
    // },
    // {
    //     "name": "subjects.index",
    //     "path": "/subjects",
    //     "component": subjects_index
    // },
    // {
    //     "name": "student_answers.create",
    //     "path": "/student_answers/create",
    //     "component": student_answers_create
    // },
    // {
    //     "name": "student_answers.edit",
    //     "path": "/student_answers/:id/edit",
    //     "component": student_answers_edit
    // },
    // {
    //     "name": "student_answers.show",
    //     "path": "/student_answers/:id",
    //     "component": student_answers_show
    // },
    // {
    //     "name": "question_sessions.index",
    //     "path": "/question_sessions",
    //     "component": question_sessions_index
    // },
    // {
    //     "name": "question_sessions.create",
    //     "path": "/question_sessions/create",
    //     "component": question_sessions_create
    // },
    // {
    //     "name": "question_likes.create",
    //     "path": "/question_likes/create",
    //     "component": question_likes_create
    // },
    // {
    //     "name": "question_discussions.create",
    //     "path": "/question_discussions/create",
    //     "component": question_discussions_create
    // },
    // {
    //     "name": "question_discussions.edit",
    //     "path": "/question_discussions/:id/edit",
    //     "component": question_discussions_edit
    // },
    // {
    //     "name": "question_discussions.show",
    //     "path": "/question_discussions/:id",
    //     "component": question_discussions_show
    // },
    // {
    //     "name": "discussion_reports.create",
    //     "path": "/discussion_reports/create",
    //     "component": discussion_reports_create
    // },
    // {
    //     "name": "question_suggestions.create",
    //     "path": "/question_suggestions/create",
    //     "component": question_suggestions_create
    // },
    // {
    //     "name": "question_videos.index",
    //     "path": "/question_videos",
    //     "component": question_videos_index
    // },
    // {
    //     "name": "question_videos.show",
    //     "path": "/question_videos/:id",
    //     "component": question_videos_show
    // },
    // {
    //     "name": "question_favorites.create",
    //     "path": "/question_favorites/create",
    //     "component": question_favorites_create
    // },
    // {
    //     "name": "notes.create",
    //     "path": "/notes/create",
    //     "component": notes_create
    // },
    // {
    //     "name": "notes.edit",
    //     "path": "/notes/:id/edit",
    //     "component": notes_edit
    // },
    // {
    //     "name": "course_prices.index",
    //     "path": "/course_prices",
    //     "component": course_prices_index
    // },
    // {
    //     "name": "discussion_likes.create",
    //     "path": "/discussion_likes/create",
    //     "component": discussion_likes_create
    // },
    // {
    //     "name": "video_likes.create",
    //     "path": "/video_likes/create",
    //     "component": video_likes_create
    // },
] ;

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
